module.exports = __webpack_public_path__ + "static/media/Pillnotes_Home_Austin.3576ba39.png";


//////////////////
// WEBPACK FOOTER
// ./src/LandingPage/images/Pillnotes_Home_Austin.png
// module id = 1451
// module chunks = 0